var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-file"
  }, [_vm.row ? _c('b-modal', {
    attrs: {
      "id": "repSuccessModal",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "repRejectModal-header text-center"
        }, [_c('h4', [_vm._v("Approval Request")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }], null, false, 3451724542)
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "repRejectModal-form text-center"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/approve.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("You have been approved the request . A charge of "), _c('b', [_vm._v("$00.00")]), _vm._v(" has been applied to the member’s card")]), _c('div', {
    staticClass: "try-again"
  }, [_vm._v("Back to Request")])])])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }